import React from 'react';

import { DarkSkeleton } from '@eika/skeleton';

import { ProgressBarSkeleton } from '../../components/ProgressBar';

const SalaryInfoSkeleton: React.FC = () => {
    return (
        <div className="salary-info-card">
            <div className="salary-info__img-skeleton">
                <DarkSkeleton width={60} height={90} />
            </div>
            <div className="salary-info__amount-container">
                <div className="salary-info__account">
                    <DarkSkeleton height={16} width={90} />
                </div>
                <div className="salary-info__next-salary">
                    <DarkSkeleton height={14} width={70} />
                </div>
                <div className="salary-info__amount">
                    <DarkSkeleton height={40} width={200} />
                </div>
            </div>
            <div className="salary-info__progress-container">
                <ProgressBarSkeleton
                    className="salary-info__progress-bar-skeleton"
                    labelSkeleton={
                        <div className="salary-info__progress-text">
                            <strong>
                                <DarkSkeleton height={16} width={170} />
                            </strong>
                        </div>
                    }
                />
                <ProgressBarSkeleton
                    className="salary-info__progress-bar-skeleton"
                    labelSkeleton={
                        <div className="salary-info__progress-text">
                            <strong>
                                <DarkSkeleton height={16} width={170} />
                            </strong>
                        </div>
                    }
                />
            </div>
        </div>
    );
};

export default SalaryInfoSkeleton;
